import React, { Component } from 'react';
import { View, Text } from 'react-native';
import { SForm, SNavigation, SPage, SPopup, SText, STheme, SView, Upload } from 'servisofts-component';
import ActionMusculoPublicacion from './ActionMusculoPublicacion';
import Container from '../../../../Components/Container';
import SSocket from 'servisofts-socket';
import root from "./root"
export default class CrearPublicacion extends Component {
    state = {
        loading: false,
    }

    static open({ data, key_musculo, callback }) {
        SPopup.open({
            key: "popup_crear_musculo",
            content: <SView backgroundColor={STheme.color.background} style={{ borderRadius: 8, maxWidth: 300 }} padding={16} withoutFeedback col={"xs-11"}>
                <CrearPublicacion popup data={data} key_musculo={key_musculo} callback={callback} />
            </SView>
        })
    }

    async subirFoto(resp) {
        if (this.form) {

            const files1 = this.form.getFiles().foto;
            if (Array.isArray(files1)) {
                console.log("files", files1);
                await Upload.sendPromise({ file: files1[0].file }, SSocket.api.root + "upload/tutorial_musculo_publicacion/" + resp?.key + "_imagen");
            }

            const files = this.form.getFiles().video;
            if (Array.isArray(files)) {
                console.log("files", files);
                await Upload.sendPromise({ file: files[0].file }, SSocket.api.root + "upload/tutorial_musculo_publicacion/" + resp?.key + ".mp4");
            }
        }
    }

    renderForm() {

        return <SForm
            ref={(ref) => this.form = ref}
            inputs={{
                "foto": {
                    label: "Imagen", isRequired: false, type: "image",
                    defaultValue: this.props?.data?.key ? SSocket.api.root + "tutorial_musculo_publicacion/" + this.props?.data?.key + "_imagen" : ""
                },
                "video": {
                    label: "Video", isRequired: true, type: "file",

                    defaultValue: this.props?.data?.key ? SSocket.api.root + "tutorial_musculo_publicacion/" + this.props?.data?.key + ".mp4" : ""
                },
                "descripcion": {
                    label: "Descripcion de la publicacion", isRequired: true, type: "text",
                    defaultValue: this.props?.data?.descripcion,
                },
                "index": {
                    label: "Index", isRequired: false, type: "number",
                    defaultValue: this.props?.data?.index
                }
            }}
            onSubmit={(values) => {
                if (this.state.loading) return;
                if (this.props.data) {
                    ActionMusculoPublicacion.editar({
                        ...this.props.data,
                        descripcion: values.descripcion
                        , index: values.index
                    }).then(async (resp) => {
                        await this.subirFoto(resp);
                        if (this.props.callback) {
                            this.props.callback();
                        }
                        if (this.props.popup) {
                            SPopup.close("popup_crear_musculo");
                        } else {
                            SNavigation.goBack();
                        }
                        if (root.INSTANCE) root.INSTANCE.componentDidMount();
                    }).catch((e) => {
                        console.log("error", e);
                    })
                } else {

                    this.setState({ loading: true });

                    console.log("cargando publicacion");
                    ActionMusculoPublicacion.crear({
                        key_tutorial_musculo: this.props.key_musculo,
                        descripcion: values.descripcion,
                        index: values.index
                    }).then(async (resp) => {
                        await this.subirFoto(resp);

                        if (this.props.callback) {
                            this.props.callback();
                        }
                        if (this.props.popup) {
                            SPopup.close("popup_crear_musculo");
                        } else {
                            SNavigation.goBack();
                        }


                        if (root.INSTANCE) root.INSTANCE.componentDidMount();
                    }).catch((e) => {
                        console.log("error", e);
                    })
                }

            }}
            onSubmitName={this.state.loading ? "Cargando..." : "Guardar"}
            onSubmitDisabled={this.state.loading}


        />
    }

    render() {
        if (this.props.popup) {
            return <SView col={"xs-12"} center>
                <SText>{"Crear Publicacion"}</SText>
                {this.renderForm()}
            </SView>
        }
        return <SPage title={"Crear Publicacion"} {...this.props.page}>
            <Container>
                {this.renderForm()}
            </Container>
        </SPage>
    }
}
